export LoginPage from './user/Login'
export RegisterPage from './user/Register'
export WeChatPage from './user/WeChat'
export ForgetPage from './user/Forget'
export DefaultPage from './master/Default'
export ErrorNotFoundPage from './errors/NotFound'
// export ExpirePage from './user/Expire'
export EChartCarousel from 'yxyweb/common/components/echart/panel/eChartCarousel'



// WEBPACK FOOTER //
// ./src/common/containers/index.jsx